var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.loading)?_c('div',{staticClass:"mx-auto my-auto"},[_c('RotateLoader',{attrs:{"color":"#2976D2"}})],1):_vm._e(),(!_vm.loading)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }